import team_image_1 from '@/images/gallery/team_image_1.jpg'
export default {
  "header": {
    "support": "ادعمونا",
    "phone": "(+228) 79569276 / 90858351",
    "email": "البريد الإلكتروني: associationdaideauxhandicapesh@gmail.com / aplahaplah02@gmail.com",
    "language": "اللغة",
    "languages": {
      "arabic": "العربية",
      "french": "الفرنسية",
      "english": "الإنجليزية"
    },
    "menu": {
      "home": "الرئيسية",
      "objectives": "الأهداف",
      "about": "من نحن",
      "leaders": "القادة",
      "gallery": "معرض الصور",
      "contact": "اتصل بنا"
    },
    "donate": "تبرع الآن"
  },
  "banner": {
    "title1": "لنتحد",
    "title2": "لندعم المحتاجين",
    "title3": "نبني عالمًا شاملًا،",
    "title4": "خطوة بخطوة"
  },
  "about": {
  "title": "حول جمعية المساعدة للمسلمين في وضعية صعبة",
  "description": "جمعية المساعدة لذوي الإعاقة من المسلمين (AS.A.HA.M) هي منظمة غير حكومية أسسها مسلمون وشباب ملتزمون في منطقة الهضاب بجمهورية توغو. تعمل الجمعية على تعزيز كرامة الإنسان من خلال تنفيذ إجراءات ملموسة لتلبية الاحتياجات الخاصة للمجتمعات، وخاصة احتياجات الأشخاص في وضعية صعبة.",
  "origin": {
    "title": "الأصل والتأسيس",
    "items": [
      "أُنشئت بروح من التضامن الإسلامي والإنساني.",
      "تأسست بهدف أساسي يتمثل في الاستجابة للتحديات التي يواجهها الأشخاص في وضعية صعبة.",
      "تهدف إلى التوسع تدريجياً على المستوى الوطني والإقليمي، ولا سيما في غرب إفريقيا."
    ]
  },
  "mission": {
    "title": "المهمة والقيم",
    "items": [
      "المهمة الرئيسية: تحسين جودة حياة الأشخاص في وضعية صعبة مع دعم إدماجهم الاجتماعي والاقتصادي.",
      "القيم الأساسية: احترام كرامة الإنسان، التضامن المجتمعي، والمسؤولية الوطنية."
    ]
  },
  "vision": {
    "title": "رؤية المؤسسين",
    "items": [
      "العمل بروح الخدمة المشتركة داخل المجتمع الإسلامي والوطني.",
      "الالتزام بالواجبات الدينية والاجتماعية والإنسانية في أنشطتهم."
    ]
  }
}
,
  "objectives": {
    "title": "الأهداف",
    "items": [
      {
        "title": "مراكز التعليم",
        "description": "إنشاء مراكز تعليمية يمكن الوصول إليها لجميع الأجيال."
      },
      {
        "title": "الوصول إلى مياه الشرب",
        "description": "بناء الآبار والحفر في المناطق الريفية والحضرية لتحسين التنمية الاجتماعية والبشرية."
      },
      {
        "title": "تعزيز اللغات العالمية",
        "description": "تشجيع تعلم اللغات العربية والفرنسية والإنجليزية لتحسين الاندماج والتواصل على المستوى العالمي."
      },
      {
        "title": "التدريب وتمكين القدرات",
        "description": "تنظيم الندوات والأعمال التطبيقية لتشجيع التنمية الذاتية في القطاعين العام والخاص."
      },
      {
        "title": "تعزيز العلاقات الأخوية",
        "description": "تعزيز التعاون بين الجمعيات الإسلامية وغير الإسلامية لأهداف مشتركة، لا سيما تعزيز الثقافة الإسلامية."
      }
    ]
  },
  "achievements": {
    "title": "إنجازاتنا"
  },
  "gallery": {
    "title1": "معرض صور AS.A.HA.M",
    "title2": "صور شراكة AS.A.HA.M و Matw Project",
    "filters": {
      "all": "الكل",
      "medical": "المساجد",
      "mosque": "المساجد",
      "shelter": "الحفر",
      "water": "المياه",
      "donation": "التبرعات",
      "well": "الآبار"
    }
  },
  "leaders": {
    "title": "القادة",
    "members": [
      {
        "name": "علي تيرو عبد الهادي",
        "position": "الرئيس",
        "photo":team_image_1
      },
      {
        "name": "إدريسو عبد الرشيد",
        "position": "الأمين العام",
        "photo":team_image_1
      },
      {
        "name": "تشا كوما زوبيرو",
        "position": "مندوب المشاريع",
        "photo":team_image_1
      },
      {
        "name": "جيبريللا سومياتو",
        "position": "المحاسب",
        "photo":team_image_1
      }
    ]
  },
  "contact": {
    "title": "اتصل بنا",
    "subtitle": "نعمل معًا لصنع الفرق",
    "form": {
      "name": "اسمك",
      "email": "البريد الإلكتروني",
      "phone": "الهاتف",
      "help": "كيف يمكننا مساعدتك؟",
      "message": "الرسالة",
      "submit": "إرسال الرسالة"
    },
    "address": "ص.ب: 361 كباليمي - توغو",
    "phone": "الهاتف: (+228) 79569276 / 90858351",
    "email": "associationdaideauxhandicapesh@gmail.com"
  },
  "footer": {
    "newsletter": {
      "title": "اشترك في نشرتنا الإخبارية للحصول على التحديثات",
      "placeholder": "أدخل بريدك الإلكتروني",
      "button": "إرسال"
    },
    "copyright": "حقوق النشر © 2024 AS.A.HA.M. جميع الحقوق محفوظة."
  }
}